import React, { useState, useEffect, createContext } from 'react';

// Hardcoded token-based users
const USERS = [
  {
    id: 'admin',
    username: 'Admin',
    accessToken: 'admin2024',
    role: 'admin',
    email: 'landonmayo722@gmail.com'
  },
  {
    id: 'attorney',
    username: 'Attorney',
    accessToken: 'atkinson2024',
    role: 'user',
    email: 'attorney@example.com'
  }
];

export const AuthContext = createContext({
  authorized: false,
  isAdmin: false,
  user: null,
  login: async () => {},
  logout: async () => {}
});

const AuthWrapper = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [form, setForm] = useState({ accessToken: '' });

  // Token-based login
  const handleLogin = async () => {
    setLoginError('');
    const found = USERS.find(u => u.accessToken === form.accessToken.trim());
    if (found) {
      setUser(found);
      setAuthorized(true);
    } else {
      setUser(null);
      setAuthorized(false);
      setLoginError('Invalid access token.');
    }
  };

  const handleLogout = async () => {
    setUser(null);
    setAuthorized(false);
    setForm({ accessToken: '' });
  };

  const authContextValue = {
    authorized,
    isAdmin: user?.role === 'admin',
    user,
    login: handleLogin,
    logout: handleLogout
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  if (!authorized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-light-gray">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
          <div className="text-center mb-6">
            <div className="case-badge mx-auto inline-block mb-4">Mayo v. Montgomery County</div>
            <h1 className="text-xl font-bold mb-2">Legal Case Platform</h1>
            <p className="text-gray-600">Enter your access token to sign in</p>
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">Access Token</label>
            <input
              type="text"
              value={form.accessToken}
              onChange={e => setForm({ ...form, accessToken: e.target.value })}
              placeholder="Access Token"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent"
              autoComplete="off"
              onKeyPress={e => e.key === 'Enter' && handleLogin()}
            />
            {loginError && <div className="text-red-600 text-sm mt-2">{loginError}</div>}
          </div>
          <button
            onClick={handleLogin}
            className="w-full bg-navy hover:bg-opacity-90 text-white px-4 py-3 rounded font-medium"
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthWrapper;